/*
 * @Description:
 * @Author: lz
 * @Date: 2021-06-16 09:49:32
 * @LastEditTime: 2021-06-23 15:51:21
 * @LastEditors: lz
 */
import axios from "axios";
import getSign from "./sign";
// import { getToken } from "@/utils/auth";
// import router from "@/router";
import { message } from "ant-design-vue";

const paramsKey = ["tenant", "page", "uid", "tel", "cid", "corp", "parkId", "deviceId" , "clientType"];

axios.defaults.headers["Content-Type"] = "application/json;charset=utf-8";
const service = axios.create({
  baseURL: "/api",
  timeout: 10000000,
  withCredentials: true,
});
//请求拦截器
service.interceptors.request.use(
  (config) => {
    // if(getToken()) {
    //     config.headers['Authorization'] = getToken()
    // }
    let param = getSign(config.data);
    config.headers["timeStamp"] = param.timeStamp; 
    config.headers["sign"] = param.sign;
    let search = "";
    paramsKey.forEach((i) => {
      let value = sessionStorage.getItem(i);
      search = search + i + "=" + value + "&";
    });
    search = search.substr(0, search.length - 1);
    //外部参数
    config.headers["embedParams"] = search;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
//响应拦截器
service.interceptors.response.use(
  (res) => {
    if (res.data.code === 10000) {
      message.error(res.data.message);
      return Promise.reject(res.data.message || "Error");
    } else if (res.data.code < 0) {
      message.error(res.data.message);
      return Promise.reject(res.data.message || "Error");
    } else {
      return res.data;
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);
export default service;
